module.exports = new __parcel__URL__("66401_sq.ea8d7665.jpg").toString();